export const updateTickerItems: string[] = [
  "新 · 某综艺录制现场风波，细节梳理已更新至第 3 版",
  "热 · 时间线补齐至第 6 环，关键节点已标注",
  "证 · 新增 3 条旁证材料，证据链同步更新",
  "更 · 话题墙新增 5 个讨论标签，热度持续上升",
  "序 · 深扒专题「旧闻回溯」合集已重新排序",
  "提 · 本周更新预告：行程对比与时间线交叉比对",
];

export const navLinks: { label: string; href: string }[] = [
  { label: "热度榜单", href: "#hot" },
  { label: "话题墙", href: "#topics" },
  { label: "深扒专题", href: "#features" },
  { label: "事件时间线", href: "#timeline" },
  { label: "证据链", href: "#evidence" },
];

export const heroEntries: {
  key: string;
  label: string;
  desc: string;
  href: string;
  icon: string;
}[] = [
  { key: "rank", label: "本期热度榜", desc: "24 小时内讨论最猛", href: "#hot", icon: "ri-fire-line" },
  { key: "topic", label: "话题标签墙", desc: "按标签横向追更", href: "#topics", icon: "ri-price-tag-3-line" },
  { key: "feature", label: "深扒专题合集", desc: "完整脉络一次看完", href: "#features", icon: "ri-stack-line" },
  { key: "line", label: "事件时间线", desc: "按节点复盘全程", href: "#timeline", icon: "ri-time-line" },
];

export const hotRanking: {
  rank: number;
  title: string;
  summary: string;
  tag: string;
  heat: string;
  trend: string;
  up: boolean;
  thumb: string;
}[] = [
  {
    rank: 1,
    title: "录制现场流程争议：从路透到工作室回应",
    summary: "以现场时间戳为轴，对比三段不同来源的路透素材，还原争议发生的顺序。",
    tag: "时间线",
    heat: "9.8 万",
    trend: "+182%",
    up: true,
    thumb:
      "https://readdy.ai/api/search-image?query=Abstract%20conceptual%20still%20life%20with%20a%20magnifying%20glass%20over%20scattered%20documents%20and%20newspaper%20clippings%20on%20a%20dark%20wooden%20desk%2C%20dramatic%20side%20lighting%2C%20deep%20shadows%2C%20warm%20amber%20and%20crimson%20tones%2C%20editorial%20mystery%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20no%20faces&width=400&height=400&seq=hot-thumb-01&orientation=squarish",
  },
  {
    rank: 2,
    title: "品牌合作临时调整：公告口径前后不一致",
    summary: "整理三次公开公告的措辞变化，标注删改位置与对应时间。",
    tag: "证据",
    heat: "7.4 万",
    trend: "+96%",
    up: true,
    thumb:
      "https://readdy.ai/api/search-image?query=Abstract%20evidence%20board%20with%20red%20strings%20connecting%20pinned%20notes%20on%20a%20corkboard%2C%20dim%20moody%20lighting%2C%20cinematic%20investigation%20mood%2C%20warm%20brown%20and%20crimson%20tones%2C%20shallow%20depth%20of%20field%2C%20artistic%20conceptual%20photography%2C%20no%20readable%20text%2C%20no%20faces&width=400&height=400&seq=hot-thumb-02&orientation=squarish",
  },
  {
    rank: 3,
    title: "旧闻回溯：两年前的同款争议被重新翻出",
    summary: "把旧报道与新素材并排比对，找出被忽略的细节差异。",
    tag: "内幕",
    heat: "6.1 万",
    trend: "+61%",
    up: true,
    thumb:
      "https://readdy.ai/api/search-image?query=Folded%20newspaper%20stack%20with%20dramatic%20spotlight%20and%20smoke%20haze%20on%20a%20dark%20concrete%20surface%2C%20moody%20editorial%20atmosphere%2C%20warm%20amber%20highlights%2C%20deep%20vignette%20shadows%2C%20conceptual%20still%20life%20photography%2C%20minimal%2C%20no%20text%2C%20no%20faces&width=400&height=400&seq=hot-thumb-03&orientation=squarish",
  },
  {
    rank: 4,
    title: "行程对比表格流出：时间冲突点集中在两天",
    summary: "以公开行程为底稿，标注无法同时成立的时间段。",
    tag: "细节分析",
    heat: "5.3 万",
    trend: "+38%",
    up: true,
    thumb:
      "https://readdy.ai/api/search-image?query=Closed%20vintage%20folder%20with%20red%20stamp%20seal%20on%20a%20dark%20desk%20beside%20a%20fountain%20pen%2C%20moody%20low%20key%20lighting%2C%20warm%20tones%20with%20crimson%20accent%2C%20investigative%20editorial%20concept%2C%20artistic%20still%20life%2C%20no%20readable%20text%2C%20no%20faces&width=400&height=400&seq=hot-thumb-04&orientation=squarish",
  },
  {
    rank: 5,
    title: "舆论走向复盘：三天内的情绪拐点出现在哪",
    summary: "按小时拆解讨论量变化，定位情绪反转的触发节点。",
    tag: "深扒",
    heat: "4.7 万",
    trend: "-12%",
    up: false,
    thumb:
      "https://readdy.ai/api/search-image?query=Abstract%20dark%20stage%20curtain%20with%20a%20single%20beam%20of%20light%20and%20floating%20dust%2C%20dramatic%20theatrical%20mood%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20cinematic%20conceptual%20photography%2C%20minimal%2C%20no%20text%2C%20no%20people&width=400&height=400&seq=hot-thumb-05&orientation=squarish",
  },
];

export const topicTags: { label: string; count: number; hot: boolean }[] = [
  { label: "实时反转", count: 312, hot: true },
  { label: "聊天记录", count: 268, hot: true },
  { label: "工作室声明", count: 241, hot: true },
  { label: "行程对比", count: 197, hot: false },
  { label: "目击细节", count: 176, hot: false },
  { label: "品牌解约", count: 154, hot: true },
  { label: "旧闻回溯", count: 132, hot: false },
  { label: "证据复盘", count: 118, hot: false },
  { label: "舆论走向", count: 96, hot: false },
  { label: "时间线", count: 88, hot: false },
  { label: "采访原声", count: 74, hot: false },
  { label: "现场路透", count: 63, hot: false },
];

export const collectionFeatures: {
  title: string;
  tag: string;
  summary: string;
  readTime: string;
  date: string;
  tags: string[];
  image: string;
}[] = [
  {
    title: "录制现场争议全梳理：从路透到回应",
    tag: "深扒专题",
    summary:
      "把三段不同来源的现场素材按时间戳排好序，逐段对照官方回应，还原争议真正发生的先后顺序，并标注素材可信度等级。",
    readTime: "12 分钟",
    date: "09-08",
    tags: ["时间线", "现场路透", "证据复盘"],
    image:
      "https://readdy.ai/api/search-image?query=Dramatic%20editorial%20concept%20image%20of%20scattered%20handwritten%20letters%20and%20old%20photographs%20on%20a%20dark%20table%20under%20warm%20lamp%20light%2C%20moody%20investigative%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20warm%20amber%20and%20crimson%20tones%2C%20artistic%20still%20life%2C%20no%20faces%2C%20no%20readable%20text&width=800&height=600&seq=coll-2026-01&orientation=landscape",
  },
  {
    title: "公告措辞的三次改动，藏着哪些回避",
    tag: "证据链",
    summary:
      "并排比对三次公告原文，逐字标出新增、删改与替换，分析每一次改动的时间窗口与当时的讨论热度之间的关系。",
    readTime: "9 分钟",
    date: "09-06",
    tags: ["声明", "证据复盘", "细节分析"],
    image:
      "https://readdy.ai/api/search-image?query=Conceptual%20image%20of%20a%20long%20empty%20hallway%20with%20tall%20windows%20casting%20dramatic%20light%20and%20long%20shadows%2C%20moody%20cinematic%20atmosphere%2C%20warm%20brown%20and%20amber%20tones%2C%20deep%20vignette%2C%20architectural%20editorial%20photography%2C%20no%20people%2C%20no%20text&width=800&height=600&seq=coll-2026-02&orientation=landscape",
  },
  {
    title: "行程与时间冲突点：一张表看完两天",
    tag: "细节分析",
    summary:
      "以公开行程为底稿，把两天内所有公开露面的时间点做成对照表，标出相互冲突、无法同时成立的时间段与可能的解释。",
    readTime: "7 分钟",
    date: "09-04",
    tags: ["行程对比", "时间线", "数据整理"],
    image:
      "https://readdy.ai/api/search-image?query=Macro%20shot%20of%20unfolded%20aged%20paper%20with%20ink%20stains%20beside%20a%20broken%20wax%20seal%2C%20dramatic%20single%20light%20source%2C%20deep%20shadows%2C%20warm%20sepia%20and%20crimson%20tones%2C%20editorial%20mystery%20concept%2C%20artistic%20still%20life%2C%20no%20faces%2C%20no%20readable%20text&width=800&height=600&seq=coll-2026-03&orientation=landscape",
  },
];

export const timelineEvents: {
  phase: string;
  time: string;
  title: string;
  desc: string;
}[] = [
  {
    phase: "起点",
    time: "T-2 天",
    title: "现场素材首次流出",
    desc: "首段路透素材出现在公开平台，此时尚未出现任何官方口径。",
  },
  {
    phase: "扩散",
    time: "T-1 天",
    title: "讨论量进入第一个峰值",
    desc: "话题被大量转发，讨论从素材本身转向对当事方态度的猜测。",
  },
  {
    phase: "回应",
    time: "T 日 上午",
    title: "第一份声明发布",
    desc: "声明仅回应部分指控，对时间冲突未作说明，留下主要疑点。",
  },
  {
    phase: "反转",
    time: "T 日 下午",
    title: "第二段素材出现",
    desc: "新素材与早前说法在时间上冲突，舆论情绪出现明显拐点。",
  },
  {
    phase: "补证",
    time: "T+1 天",
    title: "旁证材料集中释出",
    desc: "多条旁证被整理成对照表，支持与反驳的说法同时增多。",
  },
  {
    phase: "沉淀",
    time: "T+2 天",
    title: "讨论回落，进入复盘期",
    desc: "热度下降，读者关注点转向完整证据链与时间线复盘的整理。",
  },
];

export const evidenceItems: {
  code: string;
  title: string;
  desc: string;
  strength: "强" | "中" | "弱";
  source: string;
}[] = [
  {
    code: "E-01",
    title: "原始现场素材（未剪辑）",
    desc: "带原始时间戳的多段素材，可交叉验证发声先后顺序。",
    strength: "强",
    source: "公开平台存档",
  },
  {
    code: "E-02",
    title: "三次公告原文对照",
    desc: "逐字比对后的改动清单，可确认措辞变化与发布时间。",
    strength: "强",
    source: "官方账号",
  },
  {
    code: "E-03",
    title: "公开行程对照表",
    desc: "整理公开行程中的时间点，标注冲突区间。",
    strength: "中",
    source: "公开行程汇总",
  },
  {
    code: "E-04",
    title: "目击者描述整理",
    desc: "多条目击者描述在细节上存在出入，仅作参考。",
    strength: "弱",
    source: "匿名整理",
  },
  {
    code: "E-05",
    title: "讨论量变化曲线",
    desc: "按小时统计的讨论量，用于定位情绪反转节点。",
    strength: "中",
    source: "话题统计",
  },
];

export const footerGroups: { title: string; links: { label: string; href: string }[] }[] = [
  {
    title: "内容分区",
    links: [
      { label: "热度榜单", href: "#hot" },
      { label: "话题标签墙", href: "#topics" },
      { label: "深扒专题合集", href: "#features" },
    ],
  },
  {
    title: "梳理工具",
    links: [
      { label: "事件时间线", href: "#timeline" },
      { label: "证据链梳理", href: "#evidence" },
      { label: "更新提醒", href: "#subscribe" },
    ],
  },
  {
    title: "阅读说明",
    links: [
      { label: "内容口径", href: "#topics" },
      { label: "素材来源", href: "#evidence" },
      { label: "纠错反馈", href: "#subscribe" },
    ],
  },
];